import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Partners from './components/Partners';
import SocialChannels from './components/SocialChannels';
import Episodes from './components/Episodes';
import Equipe from './components/Equipe';
import Partenaires from './components/Partenaires';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Partners />
      <Equipe />
      <SocialChannels />
      <Partenaires />
      <Episodes />
      <Footer />
    </div>
  );
}

export default App;

